module.exports = __webpack_public_path__ + "img/oak-green-cropped-HiRes.27e3519d.jpg";